<script>
    import { getContext } from "svelte";
    const { close } = getContext("modal");
    import { langTextStore } from "../store/langtexts.js";

    export let confirmAction = (p) => {};
    export let titleLangKey = "general-label-please-enter";
    export let contentLangKey = "general-label-please-enter-content";
    export let cancelButtonTextOverrideLangKey;
    export let actionButtonTextOverrideLangKey;
    $: cancelButtontext = $langTextStore.getText(
        cancelButtonTextOverrideLangKey || "general-label-no"
    );
    $: actionButtontext = $langTextStore.getText(
        actionButtonTextOverrideLangKey || "general-label-yes"
    );

    $: titleText = $langTextStore.getText(titleLangKey);
    $: contentText = $langTextStore.getText(contentLangKey);
    $: isTextLoaded = titleText.length > 0;
    export let inputVal = "";
    function init(p) {
        p.focus();
        p.select();
    }
</script>

<div class="modal-header">
    <h2 class="gray-6 mt-3 mb-5">{$langTextStore && titleText}</h2>
</div>
<div class="modal-body">
    {$langTextStore && contentText}<br />
    <input type="text" bind:value={inputVal} use:init />
</div>
<div class="modal-footer pt-5">
    <div class="w-100 text-right mt-4 mb-3">
        <button type="button" class="btn btn-gray width-unset " on:click={close}
            >{$langTextStore && cancelButtontext}</button
        >
        <button
            type="button"
            class="btn btn-primary width-unset"
            on:click={() => {
                confirmAction(inputVal);
                close();
            }}>{$langTextStore && actionButtontext}</button
        >
    </div>
</div>

<svelte:head>
    <style>
        .close {
            display: none !important;
        }
    </style>
</svelte:head>
